import React from "react";

import "./AwardsSection.css";

const CDN = "https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive-english";
const FORBES_30_UNDER_30 = `${CDN}/nxtwave-30-30.png`;
const BEST_EDTECH = `${CDN}/Best-edtech-company.png`;
const INDIA_GREATEST_LEADERS = `${CDN}/indias-gratestleaders-2021-22.png`;
const TRUSTED_BRAND_EDUCATION = `${CDN}/trusted-brand-in-education.png`;
const MOST_PREFERRED_BRANDS = `${CDN}/most-preferred-brands-2021.png`;

export default function AwardsSection() {
  return (
    <>
      <section>
          <div className="w-layout-blockcontainer intensive-container w-container">
            <div className="div-block-1831980521448967">
              <h2 className="h2-heading">Awards &amp; Recognition</h2>
              <div><img src={FORBES_30_UNDER_30} loading="lazy" alt="NxtWave founders featured on Forbes 30 Under 30" className="image-8128822647" />
                <div className="div-block-1831980521448968"><img src={INDIA_GREATEST_LEADERS} loading="lazy" alt="India's Greatest Brands and Leaders 2021-22" className="image-8128822648" /><img src={MOST_PREFERRED_BRANDS} loading="lazy" alt="Most Preferred Brands 2021" className="image-8128822649" /><img src={BEST_EDTECH} loading="lazy" alt="Recognised as Best Tech Skilling EdTech Company by Times Business Awards in 2022" className="image-8128822650" /><img src={TRUSTED_BRAND_EDUCATION} loading="lazy" alt="Recognised as Trusted Brand in Education by Prime Insights in 2023" className="image-8128822651" /></div>
              </div>
            </div>
          </div>
        </section>
    </>
  );
}
